
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

import { PageTabsData } from '@/models/main';

@Component({
  components: {
    Icon,
  },
})

// Parent component should have section with 'page-header' id and sections with 'attr-scroll-id="..."' attribute
export default class PageTabs extends Vue {
  @Prop({ type: Array, required: true }) public pageTabs: PageTabsData[];

  public scrollTo(sectionNumber): void {
    const el = document.querySelector(`[attr-scroll-id="${sectionNumber}"]`);
    if (el) {
      const elDistanceToTop = window.pageYOffset + el.getBoundingClientRect().top;
      const pageHeader = document.getElementById('page-header');
      const pageHeaderHeight = pageHeader ? pageHeader.clientHeight : 0;
      window.scrollTo({ top: elDistanceToTop - pageHeaderHeight + 20, behavior: 'smooth' });
    }
  }

  private handleScroll(): void {
    const pageHeader = document.getElementById('page-header');
    const pageHeaderHeight = pageHeader ? pageHeader.clientHeight : 0;
    //
    const sectionPositions: number[] = [];
    //
    this.pageTabs.map((tab, idx) => {
      tab.active = false;
      const el = document.querySelector(`[attr-scroll-id="${idx + 1}"]`);
      if (el) {
        sectionPositions.push(el.getBoundingClientRect().top - pageHeaderHeight + 10);
      }
    });
    //
    let curTab = 0;
    sectionPositions.map((position, idx) => {
      if (position < 0) {
        curTab = idx;
      }
    });
    //
    this.pageTabs[curTab].active = true;
  }

  private mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  private beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
